import { Fragment, useState } from 'react';
import { noData } from '../../../components/ExportImgFigma';
import '../styles.scss';

// import "ag-grid-community/styles/ag-grid.css";
// import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridReact } from "ag-grid-react";
import { ConfigProvider, Pagination } from 'antd';

import { MoreOutlined, SettingOutlined } from '@ant-design/icons';
import viVN from 'antd/locale/vi_VN';
import dayjs from 'dayjs';
import 'dayjs/locale/vi';
import { ListField } from '../../../api/Customer_V2/customerApi_V2';
import useToast from '../../../hook/useToast';
import { ColumnKey } from '../../Customers/Tabs/CarListCardClone';
import { FlattenedField } from '../../CustomersV2/indexV2';
import TabsFeilds from '../Modal/TabsFeilds';
import { formatNumber } from '../../../services/mixin';
dayjs.locale('vi');


interface Props {
    dataRow: any[]
    columnDefs: any[]
}

const TabTableDetail: React.FC<Props> = ({ dataRow, columnDefs }) => {

    const pushToast = useToast();

    const [isSettingShow, setSettingShow] = useState(false)

    const [dataFilterActive, setDataFilterActive] = useState<FlattenedField[]>([])
    const [dataFilterNoActive, setDataFilterNoActive] = useState<ListField[]>([])

    const [ColumnsMapShow, setColumnsMapShow] = useState<ColumnKey[]>([])

    const [demoList, setDemoList] = useState<any[]>([])
    const [rowHeight, setRowHeight] = useState(40)

    const onSaveDataFields = () => { }
    const onCloseDataFields = () => {
        setSettingShow(false)
    }

    return (
        <Fragment>
            {
                isSettingShow ?
                    <TabsFeilds
                        isSettingShow={isSettingShow}
                        dataFilterActive={dataFilterActive}
                        dataFilterNoActive={dataFilterNoActive}

                        onSaveDataFields={onSaveDataFields}
                        onClose={onCloseDataFields}
                    /> :
                    null
            }
            <div className="custom-page-css w-full flex flex-col items-center justify-between  pt-3">
                <div className="w-full flex items-center justify-end">

                    <div className="custom-page-css absolute -top-60-px z-10 flex items-center justify-end gap-3 ">
                        <div className="custom-page-css h-8 w-8 flex items-center justify-center rounded border cursor-pointer"
                            onClick={() => setSettingShow(true)}
                        >
                            <SettingOutlined />
                        </div>
                        <div className="custom-page-css h-8 w-8 flex items-center justify-center rounded border cursor-pointer">
                            <MoreOutlined />
                        </div>

                    </div>
                </div>
                <div className={` w-full`}>
                    <div className="ag-theme-alpine custom-table-ag" style={{ width: '100%' }}>
                        <AgGridReact<any>
                            rowSelection={undefined}
                            rowData={dataRow}
                            columnDefs={columnDefs}
                            //    columnDefs={memoizedColumnDefs}
                            defaultColDef={{
                                resizable: true,   // 👈 cho phép kéo rộng/hẹp cột
                                sortable: true,    // nếu muốn sắp xếp
                                // filter: true       // nếu muốn filter trong cột
                            }}
                            domLayout="autoHeight"
                            className="my-auto-height-grid"
                            rowHeight={55}
                            getRowStyle={(params: any) => ({
                                backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
                            })}
                            overlayNoRowsTemplate={`
                           <div style="text-align: center; padding: 20px;">
                           <br />
                               <img src="${noData}" alt="No data" style="max-width: 150px;" />
                           <br />
                               <div>Không có dữ liệu</div>
                           <br />
                           </div>
                           `}
                        />

                    </div>
                    <ConfigProvider locale={viVN}>
                        <div className="pagination-block">
                            <Pagination
                                showSizeChanger
                                //   pageSize={pagination.pageSize}
                                //   total={pagination.total}
                                itemRender={(page, type, originalElement) => {
                                    // Chỉ custom khi là nút số trang
                                    if (type === 'page') {
                                        return <span>{formatNumber(page)}</span>;
                                    }
                                    // prev / next / jump-prev / jump-next giữ nguyên
                                    return originalElement;
                                }}
                                //   showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, pagination.current).totalPage} trang`}
                                className='rs-pagination'
                            //   onChange={onPaginationChange}

                            />
                        </div>
                    </ConfigProvider>
                </div>
            </div>
        </Fragment>
    )

}

export default TabTableDetail